import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const GRADE_LEVEL = 'grade_level'
const COURSE = 'course'
const ACADEMIC_PERIOD = 'academic_period'
const NUMBER = 'number'
const TITLE = 'title'
const DURATION = 'duration'
const PERIOD = 'period'

const DESCRIPTION = 'description'
const STUDENT_LEARNING_OBJECTIVES = 'student_learning_objectives'
const ESSENTIAL_QUESTIONS = 'essential_questions'
const ENDURING_UNDERSTANDING = 'enduring_understanding'
const VOCABULARY = 'vocabulary'
const INSTRUCTIONAL_STRATEGIES = 'instructional_strategies'
const ACTIVITES = 'activities'
const ASSESSMENT = 'assessment'
const DIFFERENTIATION = 'differentiation'
const REFLECTION = 'reflection'
const EXTENSION = 'extension'
const FAMILY_CONNECTION = 'family_connection'
const SEQUENCE = 'sequence'

const MATERIALS = 'materials'

/**
 * Form model
 */
const formModel = () => {
  return {
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
    },
    [COURSE]: {
      label: `${t('common.course')}`,
      name: COURSE,
      required: true,
    },
    [ACADEMIC_PERIOD]: {
      label: `${t('school.academic-period')}`,
      name: ACADEMIC_PERIOD,
    },
    [NUMBER]: {
      label: `${t('common.unit-number')}`,
      name: NUMBER,
    },
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [DURATION]: {
      label: `${t('common.duration')}`,
      name: DURATION,
    },
    [PERIOD]: {
      label: `${t('common.period')}`,
      name: PERIOD,
    },
    [DESCRIPTION]: {
      label: `${t('common.description')}`,
      name: DESCRIPTION,
    },
    [STUDENT_LEARNING_OBJECTIVES]: {
      label: `${t('setup-curriculum.student-learning-objectives')}`,
      name: STUDENT_LEARNING_OBJECTIVES,
    },
    [ESSENTIAL_QUESTIONS]: {
      label: `${t('setup-curriculum.essential-questions')}`,
      name: ESSENTIAL_QUESTIONS,
    },
    [ENDURING_UNDERSTANDING]: {
      label: `${t('setup-curriculum.enduring-understanding')}`,
      name: ENDURING_UNDERSTANDING,
    },
    [VOCABULARY]: {
      label: `${t('setup-curriculum.vocabulary')}`,
      name: VOCABULARY,
    },
    [INSTRUCTIONAL_STRATEGIES]: {
      label: `${t('setup-curriculum.instructional-strategies')}`,
      name: INSTRUCTIONAL_STRATEGIES,
    },
    [ACTIVITES]: {
      label: `${t('setup-curriculum.activities')}`,
      name: ACTIVITES,
    },
    [ASSESSMENT]: {
      label: `${t('setup-curriculum.assessment')}`,
      name: ASSESSMENT,
    },
    [DIFFERENTIATION]: {
      label: `${t('setup-curriculum.differentiation')}`,
      name: DIFFERENTIATION,
    },
    [REFLECTION]: {
      label: `${t('setup-curriculum.reflection')}`,
      name: REFLECTION,
    },
    [EXTENSION]: {
      label: `${t('setup-curriculum.extension')}`,
      name: EXTENSION,
    },
    [FAMILY_CONNECTION]: {
      label: `${t('setup-curriculum.family-connection')}`,
      name: FAMILY_CONNECTION,
    },
    [SEQUENCE]: {
      label: `${t('setup-curriculum.sequence')}`,
      name: SEQUENCE,
    }, 
    [MATERIALS]: {
      label: `${t('common.resources')}`,
      name: MATERIALS,
    },  
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [GRADE_LEVEL]: null,
  [COURSE]: null,
  [ACADEMIC_PERIOD]: null,
  [NUMBER]: null,
  [TITLE]: '',
  [DURATION]: null,
  [PERIOD]: null,
  [DESCRIPTION]: '',
  [STUDENT_LEARNING_OBJECTIVES]: '',
  [ESSENTIAL_QUESTIONS]: '',
  [ENDURING_UNDERSTANDING]: '',
  [VOCABULARY]: '',
  [INSTRUCTIONAL_STRATEGIES]: '',
  [ACTIVITES]: '',
  [ASSESSMENT]: '',
  [DIFFERENTIATION]: '',
  [REFLECTION]: '',
  [EXTENSION]: '',
  [FAMILY_CONNECTION]: '',
  [SEQUENCE]: '',
  [MATERIALS]: []
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [GRADE_LEVEL]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [COURSE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [ACADEMIC_PERIOD]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [NUMBER]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [TITLE]: yup
      .string()
      .required(`${t('errors.required-error-message')}`),
    [DURATION]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [PERIOD]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
